import { TCheckCreateOrUpdateCompanyBranchOutputDto } from "@/api/services/main/company/dtos/check-create-or-update-company-branch.dto";
import { ConfirmSaveModal } from "@/components/commons/ConfirmSaveModal";
import { Linkable } from "@/components/elements/Linkable";
import { AppRoutes } from "@/routes/config";
import { FCC } from "@/types/common";
import { toNumber } from "@/utils/number";
import { getDynamicRoute } from "@/utils/url";
import { Stack, Typography } from "@mui/material";

type TCheckCreateOrUpdateCompanyBranchesModalProps = {
  existingDuplicateCompanyBranches: TCheckCreateOrUpdateCompanyBranchOutputDto[];
  confirmSave: {
    open: boolean;
    show: () => Promise<boolean>;
    confirm: () => void;
    cancel: () => void;
  };
  onClose: () => void;
};

export const ConfirmSaveCompanyBranchModal: FCC<TCheckCreateOrUpdateCompanyBranchesModalProps> = ({
  existingDuplicateCompanyBranches,
  confirmSave,
  onClose,
}) => {
  const renderDuplicateCompanyBranches = (branch: TCheckCreateOrUpdateCompanyBranchOutputDto) => {
    return (
      <Typography
        sx={{
          marginLeft: "24px",
        }}
        component="li"
        variant="subtitle1"
        key={branch.id}
      >
        <Linkable
          sx={{ display: "inline", textDecoration: "underline" }}
          target="_blank"
          href={`${getDynamicRoute(AppRoutes.companyBranchEdit, { id: toNumber(branch.id) })}`}
        >
          {branch.branchName}
        </Linkable>
      </Typography>
    );
  };

  const handleClose = () => {
    confirmSave.cancel();
    onClose();
  };

  return (
    <ConfirmSaveModal open={confirmSave.open} onOk={confirmSave.confirm} onClose={handleClose}>
      <Stack sx={{ display: "block" }} my={2}>
        <Typography variant="subtitle1">{`勤務先　事業所名（${existingDuplicateCompanyBranches[0]?.branchName}）が以下の事業所と重複しています。登録を続けてもよろしいですか？`}</Typography>
        <Stack>{existingDuplicateCompanyBranches?.map(renderDuplicateCompanyBranches)}</Stack>
      </Stack>
    </ConfirmSaveModal>
  );
};
